import { navigateToBookingsCalendarPage } from '@wix/bookings-catalog-calendar-viewer-navigation';
import { CreateActionParams } from '../actions';
import {
  BookingsGroup,
  CancelModalClickValues,
  MemberAreaClickActions,
  RescheduleButtonOrigin,
} from '../../types';
import { bookingsLoginUserAccountSeeAllServicesClick } from '@wix/bi-logger-wixboost-ugc/v2';
import { ExperimentsConsts } from '../../consts/experiments';
import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
import { getBasket } from '../../utils/mappers/bookings-mapper/bookings-mapper';

export type ClickOnReschedule = (args: {
  group: BookingsGroup;
  origin: RescheduleButtonOrigin;
}) => void;

export function createClickOnRescheduleAction({
  getControllerState,
  context,
}: CreateActionParams): ClickOnReschedule {
  return async ({ group, origin }) => {
    const { flowAPI, biLogger, api } = context;
    const { wixCodeApi, platformAPIs } = flowAPI.controllerConfig;
    const [state] = getControllerState();
    const slug = group.bookings[0].service?.mainSlug?.name;
    const service = group.bookings[0].service;
    const order = group.order;
    const isAppointmentWithAddOns =
      flowAPI.experiments.enabled(ExperimentsConsts.AddonsUOU) &&
      service?.type === ServiceType.APPOINTMENT &&
      !!service?.addOnDetails?.length;

    const selectedTab = state.selectedTab.type;

    if (origin === RescheduleButtonOrigin.ActionMenu) {
      biLogger?.report(
        bookingsLoginUserAccountSeeAllServicesClick({
          action: MemberAreaClickActions.Reschedule,
          extraInfo: JSON.stringify({
            serviceId: group.bookings[0].service?.id,
            contactId: group.bookings[0].contactId,
          }),
          bookingId: group.bookings[0].bookingId,
          referralInfo: selectedTab,
        }),
      );
    } else if (origin === RescheduleButtonOrigin.CancellationModal) {
      if (biLogger) {
        api.logCancelBi({
          biLogger,
          selectedTab,
          clickValue: CancelModalClickValues.Reschedule,
        });
      }
    }

    try {
      await navigateToBookingsCalendarPage(wixCodeApi, platformAPIs as any, {
        serviceSlugOrBasket: isAppointmentWithAddOns
          ? getBasket({ service, order })
          : slug,
        navigationContext: {
          bookingId: group.bookings[0].bookingId,
          autoOpenPreferencesModal: isAppointmentWithAddOns ? false : undefined,
        },
      });
    } catch {
      wixCodeApi.location.to?.('/');
    }
  };
}
